import React, { useState } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Testimonial from '../Testimonial';
import Div from '../Div';
import Spacing from '../Spacing';
const testimonialData = [
  {
    testimonialThumb: '/images/testimonial_1.png',
    testimonialText:
      `Working with DappsterStudio on our decentralized application was a game-changer! Their team delivered a robust, scalable solution with a seamless interface that exceeded our expectations. We couldn't have asked for a better partner in bringing our blockchain idea to life.`,
    avatarName: 'Emma L.',
    avatarDesignation: 'Blockchain Entrepreneur',
    ratings: '4',
  },
  {
    testimonialThumb: '/images/testimonial_2.png',
    testimonialText:
      `DappsterStudio's expertise in smart contract development is unparalleled. They designed and implemented secure contracts for our project, ensuring efficiency and trustworthiness. Their attention to detail and professionalism made the process effortless.`,
    avatarName: 'Raj P.',
    avatarDesignation: 'Blockchain Project Manager',
    ratings: '5',
  },
  {
    testimonialThumb: '/images/testimonial_3.png',
    testimonialText:
      `DappsterStudio turned our vision into reality with a high-performance mobile app that our users love. The responsiveness and user-friendly design have taken our business to the next level. Highly recommend their team!`,
    avatarName: 'Sophia M.',
    avatarDesignation: 'Startup Founder',
    ratings: '4.5',
  },
  {
    testimonialThumb: '/images/testimonial_4.png',
    testimonialText:
    `We needed a custom Telegram bot to streamline our business operations, and DappsterStudio delivered brilliantly. Their solution was tailor-made to our needs, and the team's support throughout the process was fantastic.`,
    avatarName: 'Michael H.',
    avatarDesignation: 'Operations Manager',
    ratings: '4.5',
  },
  {
    testimonialThumb: '/images/testimonial_5.png',
    testimonialText:
    `The team at DappsterStudio created an immersive gaming experience that our players can't get enough of! Their use of cutting-edge technology and engaging gameplay mechanics set our game apart in a crowded market. We're thrilled with the results!`,
    avatarName: 'Liam T.',
    avatarDesignation: 'Game Studio CEO',
    ratings: '5',
  },
];

export default function TestimonialSlider() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  return (
    <>
      <Div className="cs-gradient_bg_1 cs-shape_wrap_3 cs-parallax">
        <Spacing lg="130" md="80" />
        <Div className="cs-shape_3 cs-to_up">
          <img src="/images/shape_1.svg" alt="Shape" />
        </Div>
        <Div className="container">
          <Div className="cs-testimonial_slider">
            <Div className="cs-testimonial_slider_left">
              <Slider
                asNavFor={nav1}
                ref={slider2 => setNav2(slider2)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                centerMode={true}
                centerPadding="0px"
                arrows={false}
              >
                {testimonialData.map((item, index) => (
                  <Div className="slider-nav_item" key={index}>
                    <Div className="cs-rotate_img">
                      <Div className="cs-rotate_img_in">
                        <img src={item.testimonialThumb} alt="Thumb" />
                      </Div>
                    </Div>
                  </Div>
                ))}
              </Slider>
            </Div>
            <Div className="cs-testimonial_slider_right">
              <Slider
                asNavFor={nav2}
                ref={slider1 => setNav1(slider1)}
                prevArrow={<SlickArrowLeft />}
                nextArrow={<SlickArrowRight />}
                className="cs-arrow_style1"
              >
                {testimonialData.map((item, index) => (
                  <Div key={index}>
                    <Testimonial
                      testimonialText={item.testimonialText}
                      avatarName={item.avatarName}
                      avatarDesignation={item.avatarDesignation}
                      ratings={item.ratings}
                    />
                  </Div>
                ))}
              </Slider>
            </Div>
          </Div>
        </Div>
        <Spacing lg="130" md="80" />
      </Div>
    </>
  );
}
